import { deleteToken } from 'src/utils/extractUserToken';

const { default: getData } = require('../../dataFetcher/getDataFetcher');
const BaseUrl = process.env.REACT_APP_BACKEND_URL;


export const fetchScanData = async (startDate, endDate, token) => {
  var parmas = null;

  let url = `${BaseUrl}tracking/statistics`;

  if (startDate !== null && endDate !== null) {
    url += `?date_range=${startDate}-${endDate}`;
  }

  try {
    const data = await getData(url, parmas=parmas, token=token);

    return data;
  } catch (error) {
    console.log('Error fetching scan status:', error);
    if (error?.response?.status == "401"){
      deleteToken()
    }
    throw error;
  }
};


export const fetchShippingStatisticData = async (startDate, endDate, token) => {
  var parmas = null;

  let url = `${BaseUrl}tracking/statistics_live`;

  if (startDate !== null && endDate !== null) {
    url += `?date_range=${startDate}-${endDate}`;
  }

  try {
    const data = await getData(url, parmas=parmas, token=token);

    return data;
  } catch (error) {
    console.log('Error fetching scan status:', error);
    if (error?.response?.status == "401"){
      deleteToken()
    }
    throw error;
  }
};


export const fetchReturnedStatisticsData = async (startDate, endDate, token) => {
  let apiURL = `${BaseUrl}tracking/returned-statistics`;
  if (startDate !== null && endDate !== null) {
    apiURL += `?date_range=${startDate}-${endDate}`;
  }
  try { 
    const response = await getData(apiURL, null, token);
    return response;
  } catch (error) {
    console.log('Error fetching returned statistics:', error);
    if (error?.response?.status == "401"){
      deleteToken()
    }
    throw error;
  }
};

export const fetchReturnedMetricsData = async (startDate, endDate, token) => {
  let apiURL = `${BaseUrl}tracking/returned-metrics`;
  if (startDate!== null && endDate!== null) {
    apiURL += `?date_range=${startDate}-${endDate}`;
  }
  try { 
    const response = await getData(apiURL, null, token);
    return response;
  } catch (error) {
    console.log('Error fetching returned metrics:', error);
    if (error?.response?.status == "401"){
      deleteToken()
    }
    throw error;
  }
};